export interface IGrowthRate {
    year: number,
    value: string,
    valid: boolean
}
